import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: 'app-error-success-msg',
  templateUrl: './error-success-msg.component.html',
  styleUrls: ['./error-success-msg.component.scss']
})
export class ErrorSuccessMsgComponent implements OnInit {
  srcObject: any = [];
  constructor(
    public bsModalRef: BsModalRef
  )
  { }

  confirmClose() {
      if (this.bsModalRef.content.srcObject.type == "hca-wizard") {
          this.srcObject.action = "action2";
      }
      this.bsModalRef.hide();
  }

  action1() {
    if(this.bsModalRef.content.srcObject.type) {
      this.srcObject.action = "action1";
      //this.bsModalRef.hide();
      //this.bsModalRef = null;
    }
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/modals/error-success-msg/error-success-msg.component.ts